<template lang="html">
  <div>
    <v-snackbar
      v-model="NotifHeader"
      color="green darken-1"
      :timeout="timeout"
      bottom right
      class="HeaderNotif"
      >
      <p style="margin-bottom:0px;text-align:center;width: 100%;font-style:italic;">You have Notification</p>
    </v-snackbar>
    <v-snackbar
         v-model="ViewNotif"
         color="dark"
         :timeout="timeouts"
         top
         class="ViewNotif"
      >
         <p style="ViewNotif__Text">{{AlertText}}</p>
    </v-snackbar>
    <header class="live__header__desktop">
      <v-layout wrap>
        <v-flex md6 xs6 class="live__header__desktop--logo">
          <div class="" v-if="GET_AdditionaLinfo != null">
            <div class="server__time hidden-sm-and-down" v-show="!handleServerTime">
              Loading..
            </div>
            <div class="server__time hidden-sm-and-down" v-show="handleServerTime">
              <div class="server__time--date">
                <label>{{parseDate}}</label>
              </div>
              <div class="server__time--time">
                <!-- <label ref="hours">{{splitHours}}</label>:<label ref="minutes">{{splitMinutes}}</label> -->
                <label ref="times"></label>
                <router-link to="/student/settings">
                    <span style="color:#fff;text-decoration:underline;">({{GET_AdditionaLinfo.gmt}})</span>
                  </router-link>
                <i @click="show = !show">i</i>
              </div>
              <transition name="slide-fade">
                <div class="tooltip--server" v-show="show">
                  <span>This is time based on your timezone setting based on your last configuration, if you wish to change it you can go to Profile settings</span>
                </div>
              </transition>
            </div>
          </div>
          <img src="https://live.myneo.space/assets/b2c/img/logo_newneo.svg" height="35px;" alt="">
        </v-flex>
        <div style="width:50%;" v-if="!myData">
          <content-loader
            :height="100"
            :width="500"
            :speed="2"
            primaryColor="#e6e6e6"
            secondaryColor="#d2d2d2"
          >
            <rect x="286.63" y="44.61" rx="0" ry="0" width="0" height="0" />
        		<rect x="416.63" y="216.61" rx="0" ry="0" width="0" height="0" />
        		<rect x="309.63" y="40.61" rx="0" ry="0" width="79.04" height="9.41" />
        		<circle cx="426.79" cy="51.87" r="13.16" />
        		<rect x="309.63" y="51.61" rx="0" ry="0" width="98.36" height="10.82" />
        		<circle cx="270.08" cy="51.16" r="13.5" />
          </content-loader>
        </div>
        <v-flex md6 xs6 class="live__header__desktop--account" v-if="myData">
          <div class="live__header__desktop--notif">
            <v-menu
              bottom
              left
              >
              <v-btn
                slot="activator"
                @click.native="ButtonNotif"
                icon
              >
                <v-badge color="#f34949">
                  <span slot="badge" v-if="checkBadges"></span>
                  <v-icon color="#6c6c6c">notifications</v-icon>
                </v-badge>
              </v-btn>

              <div class="notification__title">
                <h5>Notifications</h5>
              </div>
              <v-list-tile
                v-for="(n, i) in Trigert" :key="'A' + i"
                 style="background:#fafafa;"
                 class="boxNotifetile"
              >
                <v-list-tile-content class="BoxContent">
                  <div class="boxNotif">
                    <div class="boxNotif__Vtext">
                      <div class="boxNotif__Vtext--BoxAvatar">
                      </div>
                      <div class="boxNotif__Vtext--DecTime">
                        <i class="notifText">
                          {{n.description}}
                        </i>
                        <span>{{n.created_at | dateFormat}}</span>
                      </div>
                    </div>
                  </div>
                </v-list-tile-content>
              </v-list-tile>


              <v-list-tile
                v-for="(n, index) in FilterNotifLatest" :key="index"
                 style="background:#fafafa;"
                 class="boxNotifetile"
              >
                <v-list-tile-content class="BoxContent">
                  <div class="boxNotif">
                    <div class="boxNotif__Vtext">

                      <!-- <div class="boxNotif__Vtext--BoxAvatar">
                        <v-avatar size="30" color="grey lighten-4">
                          <img :src='GET_AdditionaLinfo.avatar' alt="avatar">
                        </v-avatar>
                      </div> -->

                      <div class="boxNotif__Vtext--DecTime">
                        <i class="notifText">
                          {{n.description}}
                        </i>
                        <span>{{n.created_at | dateFormat}}</span>
                      </div>
                    </div>
                  </div>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                 style="background:#fafafa;"
                 class="boxNotifetile"
                 v-if="GetLatestNotif.data.length == 0 && Trigert.length == 0"
              >
                <v-list-tile-content class="BoxContent">
                  <div class="boxNotif">
                    <div class="boxNotif__Vtext">

                      <div class="boxNotif__Vtext--BoxAvatar">
                      </div>

                      <div class="boxNotif__Vtext--DecTime">
                        <i class="notifText" style="text-align:center;">
                          You don't have notifications yet
                        </i>
                        <span></span>
                      </div>
                    </div>
                  </div>
                </v-list-tile-content>
              </v-list-tile>

              <div class="notification__title justify-center">
                <router-link to="/student/notifications"><i @click="TrAllNotif">See All</i></router-link>
              </div>
            </v-menu>
          </div>
          <div class="live__header__desktop--account--info hidden-sm-and-down">
            <h4>{{ GET_AdditionaLinfo.fullname }}</h4>
            <h5>{{ GET_AdditionaLinfo.username }}</h5>
          </div>
          <div class="live__header__desktop--account--thumb">
            <router-link to="/student/profile">
              <v-avatar
                size="32"
                color="grey lighten-4"
              >
              <img :src='GET_AdditionaLinfo.avatar' alt="avatar">
            </v-avatar>
            </router-link>
          </div>
          <div class="live__header__desktop--menu hidden-sm-and-down">
            <v-layout row>
              <v-menu
                offset-y
                >
                <v-btn
                  slot="activator"
                  icon
                >
                  <v-icon>more_horiz</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile
                    style="background:#fafafa;"
                    class="live__header__desktop--list"
                  >
                    <v-list-tile-title>
                      <router-link to="/student/profile">Profile</router-link>
                    </v-list-tile-title>
                    <v-list-tile-title>
                      <router-link to="/student/settings">Account Setting</router-link>
                    </v-list-tile-title>
                    <v-list-tile-title>
                      <a @click="onLogout">Logout</a>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </header>
  </div>
</template>

<script>
import moment from 'moment'
import { ContentLoader } from 'vue-content-loader';
import Pusher from 'pusher-js';
export default {
  components: {
    ContentLoader
  },
  data () {
    return {
      myData: null,
      show: false,
      ShowBad: true,
      UserNameCoder: null,
      Trigert:[],
      NotifHeader:false,
      timeout:6000,
      ViewNotif:false,
      timeouts:600000,
      AlertText:''
    }
  },
  created() {
    this.TrigDispatch()
    this.UserNameCoder = this.GetUsername.encoder
  },
  mounted() {
    // Just pretend this is an AJAX call. Use your imagination.
     this.$nextTick( () => {
      setTimeout(() => {
          this.CheckLoad

      }, 2000);
    })
    this.$store.dispatch("GET_NOTIFICATIONS_LATEST");
    const pusher = new Pusher('e8e7a9c5ac18e7540533', {
      cluster: 'ap1',
      forceTLS: true
    })
    //c3d181b3d09cbe50cb20
    //e8e7a9c5ac18e7540533
    //ZHluZWQuc3R1ZGVudCsxQGdtYWlsLmNvbQ==
      var channel = pusher.subscribe(this.UserNameCoder);
      channel.bind('appointment-pusher', (data) => {
        this.TridPush(data)
      });

      // TIME SERVER THING
      const startTime = (() => {
        const userData = this.$store.state.DataAdditional
        var userTime = new Date().toLocaleString("en-US", {timeZone: userData.timezone});
        userTime = new Date(userTime);
        // console.log('current time: '+userTime.toLocaleString())
        // var today = new Date();
        let h = userTime.getHours();
        let m = userTime.getMinutes();
        let s = userTime.getSeconds();
        m = checkTime(m);
        s = checkTime(s);
        this.$refs.times.innerText =
        h + ":" + m;
        // console.log(h + ":" + m + ":" + s);
        var t = setTimeout(startTime, 500);
      });
      const checkTime = ((i) => {
        if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
        return i;
      })
      startTime(() => {
        startTime()
      })
      checkTime(() => {
        checkTime()
      });

      const updateTime = (function(){
        var stateKey, eventKey, keys = {
            hidden: "visibilitychange",
            webkitHidden: "webkitvisibilitychange",
            mozHidden: "mozvisibilitychange",
            msHidden: "msvisibilitychange"
        };
        for (stateKey in keys) {
            if (stateKey in document) {
                eventKey = keys[stateKey];
                break;
            }
        }
        return function(c) {
            if (c) document.addEventListener(eventKey, c);
            return !document[stateKey];
        }
      })();

      updateTime(() => {
        updateTime() ? checkTime() : "okay";
      });
      // TIME SERVER THING END
  },
  methods: {
    onLogout() {
      this.$store.dispatch('LOGOUT')
    },
    ButtonNotif(){
      this.$store.commit('muttShowBadges',false)
    },
    TrAllNotif(){
      this.$store.dispatch("GET_NOTIFICATIONS_ALL");
    },
    TridPush(data){
      this.Trigert.push(data)
      this.$store.commit('muttShowBadges',true)
      this.$store.dispatch("GET_DASH_UPCOMING_SESSIONS");
    },
    TrigDispatch(){
      this.$store.dispatch("GET_PROFILEADDITIONAL");
      this.$store.dispatch("GET_SERVER_TIME");
    }
  },

  computed: {
    GET_AdditionaLinfo(){
			return this.$store.state.DataAdditional
    },
    AvatarCheck(){
      return this.GET_AdditionaLinfo.avatar
    },
    getServerTime () {
      const data = this.$store.state.stateServerTime
      if (data == null) {
        return 0
      } else {
        return data.data
      }
    },
    handleServerTime () {
      let data = this.getServerTime
      if (data == 0) {
        return false
      } else {
        return true
      }
    },
    // splitHours () {
    //   const data = this.getServerTime
    //   const hours = data.substr(11, 2)
    //   return hours
    // },
    // splitMinutes () {
    //   const data = this.getServerTime
    //   const minutes = data.substr(14, 2)
    //   return minutes
    // },
    parseDate () {
      const data = moment(this.getServerTime).format('ddd, MMMM DD, YYYY')
      return data
    },
    GetLatestNotif(){
      return this.$store.state.HeaderNotifLatest
    },
    GetUsername(){
      return this.$store.state.DataAdditional
    },
    FilterNotifLatest(){
      const DataNotif = this.GetLatestNotif.data
      const items = []
        DataNotif.forEach(function (value, key) {
          moment(value.date).format('MMMM, Do YYYY')
          items.push(DataNotif);
            // console.log(key +" " + value.date+ " " + value.start_time);
         });
      function compare(a, b){
        if (a.created_at > b.created_at) return -1;
        if (a.created_at < b.created_at) return 1;
      }
      return [...DataNotif].sort(compare)
    },
    checkBadges(){
      return this.$store.state.ShowBadges
    },
    CheckLoad(){
      if (this.$store.getters.CCK_HEADER_LATEST !== 'IS NULL'){
        const ItemsCont = []
        for (var i in this.$store.getters.CCK_HEADER_LATEST){
            ItemsCont.push(this.$store.getters.CCK_HEADER_LATEST[i])
        }
        return ItemsCont
      }else{
        return 'IS NULL'
      }
    }
  },
  watch: {
    Trigert(val){
      if (val){
        // console.log(val)
      }
    },
    GetLatestNotif(val){
      if(val.data.length == 0)
      this.Trigert = []
    },
    // getServerTime (i) {
    //   let hoursLabel = this.$refs.hours;
    //   let minutesLabel = this.$refs.minutes;
    //   let totalMinutes = this.splitMinutes;
    //   let totalHours = this.splitHours;
    //   setInterval(setMin, 60000);
    //   setInterval(setHour, 3600000);
    //   function setMin() {
    //     ++totalMinutes;
    //     minutesLabel.innerHTML = min(totalMinutes % 60);
    //   }
    //   function setHour() {
    //     ++totalHours;
    //     hoursLabel.innerHTML = hour(totalHours % 24);
    //   }
    //   function min(val) {
    //     const valString = val + "";
    //     if (valString.length < 2) {
    //       return "0" + valString;
    //     } else {
    //       return valString;
    //       // console.log("min " + valString);
    //     }
    //   }
    //   function hour(val) {
    //     const valString = val + "";
    //     if (valString == 24) {
    //       return "0" + valString;
    //     } else {
    //       return valString
    //       // console.log("hour " + valString);
    //     }
    //   }
    //   clearInterval (setMin, setHour);
    // },
    CheckLoad(val){
      if (val === 'IS NULL'){
        this.TrigDispatch()
        this.$store.dispatch("GET_NOTIFICATIONS_LATEST");
        setTimeout(() => {
          if (val === 'IS NULL'){
              this.ViewNotif = true
              this.AlertText ="Something wrong, Please Reload your Browser"
              this.myData = null
              console.log(val)
          }
        }, 1000);

      }else{
        const DataProfile = val[0]
        const DataHeaderLatest = val[1]
        const DataServerTime = val[2]
        if (DataProfile == 200 && DataHeaderLatest == 200 && DataServerTime == 200){
          this.myData = 'Success'
          this.ViewNotif = false
          this.AlertText ="Success"
        }else if(DataProfile == 400 || DataHeaderLatest == 400 || DataServerTime == 400){
          this.myData = null
          this.ViewNotif = true
          this.AlertText ="Bad Request, Please try again in a few minutes"
        }else if(DataProfile == 500 || DataHeaderLatest == 500 || DataServerTime == 500){
          this.myData = null
          this.ViewNotif = true
          this.AlertText ="Server Internal Error, Please try again in a few minutes"
        }
      }
    }
  },
  filters:{
    dateFormat: function (value) {
        if (value) {
          return moment(String(value)).format('ddd, D MMMM YYYY HH:mm:ss')
        }
    },
  },
  beforeDestroy() {
    this.ViewNotif = false
    this.AlertText ="Success"

  },
  destroyed(){

    this.$store.commit('MuttAllertCont', {
        Alert : 'no',
        TextAlert : 'exit'
    })
  }
}
</script>

<style lang="scss">
  @import '../../views/content/Header.scss';
</style>



// WEBPACK FOOTER //
// src/student-components/layout/Header.vue